import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectUserPayLevels = ({ careWorkers }: RootState) => careWorkers.userPayLevels.rows;
export const selectUserPayLevelsByID = createSelector(
  [selectUserPayLevels, (_: RootState, id?: number) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);
